import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
@Component({
    template: `<router-outlet></router-outlet>`,
  standalone: false
})
export class FoodSafetyCleaningComponent {
    constructor(private http: HttpClient, translate: TranslateService) {}
}
